import { c as _c } from "react/compiler-runtime";
import { useMarkupContext } from "@context-providers/markup/markup-context";
import { useShouldShowBulkAction } from "@hooks/table/use-should-show-bulk-action";
import { BulkDeleteMarkups } from "@pages/project-details/project-markups/project-markups-bulk-actions/bulk-delete-markups";
import { BulkExportMarkups } from "@pages/project-details/project-markups/project-markups-bulk-actions/bulk-export-markups";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { useMemo } from "react";
/** List all the bulk action components for project markup table */
export function useProjectMarkupBulkActions(t0) {
  const $ = _c(26);
  const {
    markups,
    projectId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("markups");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const isAnyRowSelected = selectedEntities.length !== 0;
  const {
    hasPermissionToEditMarkup
  } = useMarkupContext();
  let t2;
  if ($[1] !== projectId) {
    t2 = getProjectByIdSelector(projectId);
    $[1] = projectId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const selectedProject = useAppSelector(t2);
  let allowedButtons;
  if ($[3] !== hasPermissionToEditMarkup || $[4] !== isAnyRowSelected) {
    allowedButtons = ["export"];
    if (isAnyRowSelected && hasPermissionToEditMarkup) {
      allowedButtons.push("deleteMarkup");
    }
    $[3] = hasPermissionToEditMarkup;
    $[4] = isAnyRowSelected;
    $[5] = allowedButtons;
  } else {
    allowedButtons = $[5];
  }
  const allowedButtonsBasedOnRowSelection = allowedButtons;
  let t3;
  if ($[6] !== allowedButtonsBasedOnRowSelection) {
    t3 = {
      allowedButtonsBasedOnRowSelection
    };
    $[6] = allowedButtonsBasedOnRowSelection;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    shouldShowBulkButtons
  } = useShouldShowBulkAction(t3);
  let t4;
  if ($[8] !== isAnyRowSelected || $[9] !== markups || $[10] !== selectedEntities) {
    t4 = isAnyRowSelected ? selectedEntities.map(_temp) : markups.map(_temp2);
    $[8] = isAnyRowSelected;
    $[9] = markups;
    $[10] = selectedEntities;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const markupIds = t4;
  let t5;
  if ($[12] !== isAnyRowSelected || $[13] !== projectId || $[14] !== selectedEntities || $[15] !== shouldShowBulkButtons) {
    t5 = shouldShowBulkButtons("deleteMarkup") ? <BulkDeleteMarkups selectedMarkups={isAnyRowSelected ? selectedEntities : []} projectId={projectId} /> : null;
    $[12] = isAnyRowSelected;
    $[13] = projectId;
    $[14] = selectedEntities;
    $[15] = shouldShowBulkButtons;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== isAnyRowSelected || $[18] !== markupIds || $[19] !== projectId || $[20] !== selectedProject?.name || $[21] !== shouldShowBulkButtons) {
    t6 = shouldShowBulkButtons("export") ? <BulkExportMarkups projectId={projectId} markupIds={markupIds} projectName={selectedProject?.name ?? ""} areEntitiesSelected={isAnyRowSelected} /> : null;
    $[17] = isAnyRowSelected;
    $[18] = markupIds;
    $[19] = projectId;
    $[20] = selectedProject?.name;
    $[21] = shouldShowBulkButtons;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6) {
    t7 = {
      deleteMarkup: t5,
      export: t6
    };
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}
function _temp2(markup) {
  return markup.id;
}
function _temp(entity) {
  return entity.id;
}